<template>
	<nav id="dashboard-header" class="navbar navbar-expand-lg navbar-dark">
		<div>
			<div>
				<a href="/home/">
					<img
						id="login-logo"
						src="/img/login-logo.png"
						alt="Logo Login"
					/>
				</a>
			</div>
			<div>
				<p v-if="user">
					Hello {{ user.first_name }} {{ user.last_name }}
				</p>
				<button @click="logout()">
					Logout
				</button>
			</div>
		</div>
	</nav>
</template>

<script>
import { mapGetters } from "vuex";
import LocaleDropdown from "./LocaleDropdown";

export default {
	name: "DashboardHeader",

	components: {
		LocaleDropdown
	},

	data: () => ({
		appName: window.config.appName
	}),

	computed: mapGetters({
		user: "auth/user"
	}),

	methods: {
		async logout() {
			// Log out the user.
			await this.$store.dispatch("auth/logout");

			// Redirect to login.
			this.$router.push({ name: "login" });
		}
	}
};
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/DashboardHeader.vue